import * as React from "react";

function SvgIcAttach(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12a5 5 0 005 5h7a1 1 0 110 2H9A7 7 0 119 5h8a5 5 0 010 10H9a3 3 0 110-6h7a1 1 0 110 2H9a1 1 0 100 2h8a3 3 0 100-6H9a5 5 0 00-5 5z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcAttach;
